import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EditableAccountDTO} from '..';

@Injectable()
export class AuthServerProvider {

    constructor(
        private http: HttpClient
    ) {}

    login (credentials): Observable<any> {
        let data = [
            `j_username=${encodeURIComponent(credentials.username)}`,
            `j_password=${encodeURIComponent(credentials.password)}`,
            `remember-me=${credentials.rememberMe}&submit=Login`].join('&');
        let headers = new HttpHeaders ({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        return this.http.post('/api/authentication', data, {
            headers
        });
    }

    logout (): Observable<Object> {
        // logout from the server
        return this.http.post('/api/logout', {});
    }

    fcLogout (): Observable<string> {
        // logout from the server
        return this.http.get('/franceconnect/logout', {responseType : 'text'});
    }

    fcUserInfo(): Observable<EditableAccountDTO> {
        return this.http
            .get<EditableAccountDTO>(`/franceconnect/userinfo`, {
                responseType: 'json'
            });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/auth-session.service.ts